/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReactNode } from "react";
import { AccountStatus } from "~/tools";

export const enum Mode {
  INCLUDE = "INCLUDE",
  EXCLUDE = "EXCLUDE",
}

export type UISidebarProps = {
  hasIcon?: boolean;
  hasSubtitle?: boolean;
};

export type Item = {
  label?: string | null;
  value?: string | null;
  status?: AccountStatus;
  selected?: boolean;
};

export type SidebarWithSelectAll = {
  onClear?: () => void;
  onSelectAll?: () => void;
};

export type SidebarWithMultiSelectProps = {
  options: Item[];
  name?: string;
  pluralName?: string;
  onClear?: () => void;
  placeholder?: string;
  onMultiSelect: (ids: string[]) => void;
  selectedOptions?: string[];
  disabled?: boolean;
  title?: string;
  showLoader?: boolean;
};

export type SidebarSelectorProps = {
  options: Item[];
  name?: string;
  pluralName?: string;
  onClick: () => void;
  isOpen: boolean;
  placeholder?: string;
  onSubmit: (id: string) => void;
  onMultiSubmit?: () => void;
  selectedOptions?: string[];
  showLoader?: boolean;
  footer?: ReactNode;
  searchFilter?: string;
  setSearchFilter?: (value: string) => void;
  removedSelections?: string[];
  selectButtonLabel?: string;
};

export type SidebarItemProps = {
  key: string;
  item: Item;
  onSubmit: (index: string) => void;
  selectedOptions?: string[];
  name?: string;
};

export type SidebarItemListProps = {
  items: Item[];
  onSubmit: (index: string) => void;
  selectedOptions?: string[];
  name?: string;
};
